module.exports = __webpack_public_path__ + "img/ddwu_gallery13.f7cbbe41.jpg";